const state = {
    columnsFilters: {},
}

export default state